import { ShieldOff, Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";

export function LicenceExpiredScreen() {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md w-full space-y-6 text-center animate-fade-in">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center">
            <ShieldOff className="w-10 h-10 text-destructive" />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold tracking-tight text-foreground">
            Licence expirée
          </h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Votre licence SMEFI a expiré. L'accès à l'application est temporairement
            suspendu jusqu'au renouvellement de votre abonnement.
          </p>
        </div>

        {/* Contact card */}
        <Card>
          <CardContent className="pt-6 space-y-4">
            <p className="text-sm font-medium text-foreground">
              Contactez-nous pour renouveler votre licence
            </p>
            <div className="space-y-3">
              <a
                href="mailto:contact@smefi.app"
                className="flex items-center gap-3 p-3 rounded-lg bg-muted hover:bg-muted/70 transition-colors group"
              >
                <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                  <Mail className="w-4 h-4 text-primary" />
                </div>
                <div className="text-left">
                  <p className="text-xs text-muted-foreground">Email</p>
                  <p className="text-sm font-medium group-hover:text-primary transition-colors">
                    contact@smefi.app
                  </p>
                </div>
              </a>
              <a
                href="tel:+33000000000"
                className="flex items-center gap-3 p-3 rounded-lg bg-muted hover:bg-muted/70 transition-colors group"
              >
                <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                  <Phone className="w-4 h-4 text-primary" />
                </div>
                <div className="text-left">
                  <p className="text-xs text-muted-foreground">Téléphone</p>
                  <p className="text-sm font-medium group-hover:text-primary transition-colors">
                    +33 (0)0 00 00 00 00
                  </p>
                </div>
              </a>
            </div>
          </CardContent>
        </Card>

        {/* Actions */}
        <div className="flex flex-col gap-2">
          <Button asChild>
            <a href="mailto:contact@smefi.app?subject=Renouvellement%20licence%20SMEFI">
              <Mail className="w-4 h-4 mr-2" />
              Demander un renouvellement
            </a>
          </Button>
          <Button variant="ghost" size="sm" onClick={handleSignOut} className="text-muted-foreground">
            Se déconnecter
          </Button>
        </div>
      </div>
    </div>
  );
}
